// Campus photo for /colleges/wake-forest-university: CC BY-SA 4.0, by Maggiehc23, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AWake_Forest.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/wake-forest-university/; credited under the photo.
const photo = {
    "slug": "wake-forest-university",
    "alt": "A brick walkway across a green quad toward the spire of Wait Chapel at Wake Forest University in Winston-Salem, North Carolina",
    "src": "/colleges/wake-forest-university/campus-1600.webp",
    "srcSmall": "/colleges/wake-forest-university/campus-800.webp",
    "srcMid": "/colleges/wake-forest-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/wake-forest-university/og.jpg",
    "title": "Wake Forest",
    "author": "Maggiehc23",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AWake_Forest.jpg",
    "read": "2026-10-01"
};

export default photo;
